module.exports = __webpack_public_path__ + "static/bg-fhe9vnw-169715e2afbfc12c8d12f5e86eaed63b.jpg";